import React from 'react';

// #412 — a non-production build (e.g. `vite build --mode staging`, which reads
// FE/.env.staging) sets VITE_ENVIRONMENT_LABEL so nobody mistakes the staging
// app for the real one. Production, local dev and E2E leave it unset and render
// nothing. Click-through (pointer-events-none) so it never blocks the UI.
export default function EnvironmentBadge() {
    const label = (import.meta.env.VITE_ENVIRONMENT_LABEL || '').trim();
    if (!label) return null;
    return (
        <div
            data-testid="environment-badge"
            className="pointer-events-none fixed bottom-2 left-1/2 -translate-x-1/2 z-[9999] rounded-full bg-amber-400/90 px-3 py-0.5 text-[11px] font-semibold uppercase tracking-wider text-black shadow"
        >
            {label}
        </div>
    );
}
